import React from 'react';
import classNames from 'classnames';
import { DatePickerVertical } from '../../../components/DatePicker/DatePickerVertical';
import { SlideType } from '../../../models';
import { Fragment } from './Fragment';
import { FragmentBody } from './FragmentBody';
import { NextButton } from './NextButton';
import { CMS } from '../../../utils/CMS';
import { ConnectedSegmentDate } from '../Segment/SegmentDate';
import { DatePickerLegends } from '../../../components/DatePicker/DatePickerLegends';
import { ConnectedFaresTrackingCalculator } from '../../../components/Calendar/Context/FaresTrackingCalculator';
import { ABUtils } from '../../../utils';
import { DatesFragmentHeader } from './DatesFragmentHeader';

export const DatesFragment = () => (
    <ConnectedSegmentDate>
        {({ dates, minDate, maxDate, setValue, value, displayFaresInCalendar }) => {
            const { isCssVariationMobile } = ABUtils.getABs();
            const isDone = !!value;
            const stop = displayFaresInCalendar;

            const wrapperClassName = classNames({
                'odf-box': true,
                'prisma-elevation-1': isCssVariationMobile,
            });

            return (
                <Fragment
                    id={SlideType.DATE}
                    isDone={isDone}
                    isEmpty={!isDone}
                    setValue={setValue}
                >
                    {({ onSelectValue }) => (
                        <React.Fragment>
                            <DatesFragmentHeader />
                            <FragmentBody padding={false}>
                                {!isCssVariationMobile && (
                                    <div className="odf-space-outer-m odf-text-soft odf-text-left odf-text-xl">
                                        <CMS id="flightsManager.selection.date.title" />
                                    </div>
                                )}
                                <DatePickerVertical
                                    dates={dates}
                                    displayFaresInCalendar={displayFaresInCalendar}
                                    value={value}
                                    minDate={minDate}
                                    maxDate={maxDate}
                                    onChange={(value) => onSelectValue(value, stop)}
                                />

                            </FragmentBody>
                            <div className={wrapperClassName} style={{ borderRadius: 0 }}>
                                <DatePickerLegends displayFaresInCalendar={displayFaresInCalendar} />
                            </div>
                            {isDone && !displayFaresInCalendar && (
                                <ConnectedFaresTrackingCalculator trackType='continue_calendar'>
                                    {({ extraTracking })=>(
                                        <NextButton extraTracking={extraTracking} testId="dates-next-btn" />
                                    )}
                                </ConnectedFaresTrackingCalculator>
                            )}
                        </React.Fragment>
                    )}
                </Fragment>
            );
        }}
    </ConnectedSegmentDate>
);
